export default __webpack_public_path__ + "static/media/bankWorldBlue.925c3c81.svg";